import React, { useState, useEffect } from "react";
import NavBarEN from "./NavBarEN";
import NavBarMobileEN from "./NavBarMobileEN";
import { useMediaQuery } from "@uidotdev/usehooks";
import FormEN from "./FormEN";
import FooterEN from "./FooterEN";
import imageSuseUvod from "../catalog/suse-slika-uvod-2025.png";
import imageSuseMetodologija1 from "../catalog/suse-slika_metodologija.png";

import imageSuseTrendovi from "../catalog/suse-slika_trendovi.png";
import imageSuseUticaj from "../catalog/suse-slika-uticaj.png";

import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import ReactHtmlParser from "html-react-parser";

export default function SuseEN() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const isTabletOrLarger = useMediaQuery("only screen and (min-width: 769px)");
  const [activeTab, setActiveTab] = useState("introduction");
  const [activePodaciTab, setActivePodaciTab] = useState("past-droughts");

  const [spei, setSpei] = useState("SPEI-3");
  const [month, setMonth] = useState("Jan");
  const [year, setYear] = useState("1950");

  const [imageSrc, setImageSrc] = useState(""); // Store image path

  // Load images from folder
  const images = require.context(
    "../slikeProslost2025",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const getSelectedImage = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };

    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];

    const imageName = `./obs_spei${speiNumber}_${year}_na_na_na_${monthNumber}_eobs.png`;

    try {
      return images(imageName);
    } catch (error) {
      console.error("Image not found:", imageName);
      return "/obs_spei3_1950_na_na_na_1_eobs.png";
    }
  };

  const imagesBuducnost = require.context(
    "../slikeBuducnost2025",
    false,
    /\.(png|jpe?g|svg)$/,
  );

  const getSelectedImageForProjekcije = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];

    // Period parsing
    const periodMap = {
      "2041-2060": "2061-2080",
      "2061-2080": "2061-2080",
      "2081-2100": "2081-2100",
    };

    const periodStr = year.split("-")[1] ? year : periodMap[year];

    const imageName = `spei${speiNumber}_${monthNumber}_${periodStr}_allpct.png`;

    try {
      return imagesBuducnost(`./${imageName}`);
    } catch (error) {
      return imagesBuducnost(`./spei3_1_2061-2080_allpct.png`);
    }
  };

  // useEffect to update image
  useEffect(() => {
    if (activePodaciTab === "past-droughts") {
      setImageSrc(getSelectedImage());
    } else if (activePodaciTab === "future-projections") {
      setImageSrc(getSelectedImageForProjekcije());
    }
  }, [spei, month, year, activePodaciTab]);

  const getDownloadDataLink = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];
    const dataFileName = `spei${speiNumber}_${monthNumber}_${year}.nc`;
    const dataFilePath = `/fajloviProslost2025/${dataFileName}`;
    return dataFilePath;
  };

  const getDownloadDataLinkForProjekcije = () => {
    const monthMap = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      June: 6,
      July: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    const monthNumber = monthMap[month];
    const speiNumber = spei.split("-")[1];
    return `/fajloviBuducnost2025/spei${speiNumber}_${monthNumber}_${year}_allpct.nc`;
  };

  const data = [
    {
      label: "INTRODUCTION",
      value: "introduction",
      desc:
        `<h2>INTRODUCTION</h2>
      <p style="margin-bottom: 10px; color: #000;">
        The occurrence of drought is a complex, multi-layered, and usually long-lasting process in which initial anomalies in meteorological conditions over an area gradually spread through other elements of the geophysical system, and sometimes impact socio-economic conditions. There are different types of drought: meteorological, agricultural, hydrological, and socioeconomic, each reflecting a particular phase in the development of this phenomenon. Initially, drought appears as a meteorological anomaly, such as reduced precipitation, often accompanied by elevated temperatures. As time passes, these initial disturbances gradually transfer to other system components. Through interactions with soil, vegetation, and elements of the hydrological cycle, these initial impulses become increasingly complex with longer-lasting consequences. Reduced precipitation and elevated temperatures affect soil moisture reduction, leading to agricultural drought. Prolonged lack of moisture in the soil can further trigger various disturbances in it, vegetation, and the hydrological cycle, creating conditions for hydrological drought. Finally, accumulated effects transition into socioeconomic consequences that affect people, infrastructure, and the economy. This sequence of events shows that drought cannot be viewed merely as a meteorological phenomenon, but as a process in which initial meteorological anomalies trigger a domino effect that shapes different types and intensities of drought.
      </p>` +
        `<p style="margin-bottom: 10px; color: #000;">
        The figure is an adapted version from Cook et al., 2018.
       </p>` +
        `<p style="color: #000;">
          Cook, B.I., Mankin, J.S. & Anchukaitis, K.J. Climate Change and Drought: From Past to Future. Curr Clim Change Rep 4, 164–179 (2018). <a href="https://doi.org/10.1007/s40641-018-0093-2" target="_blank" style="color: #60A5FA;"> https://doi.org/10.1007/s40641-018-0093-2 </a>
        
      </p>` +
        `<p></p>`,
      image: `<img src="${imageSuseUvod}" alt="Drought Introduction" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "METHODOLOGY",
      value: "methodology",
      desc:
        `<h2>METHODOLOGY</h2>
      <p style="margin-bottom: 10px; color: #000;">
      In practice, we encounter a large number of indices and indicators that can be used for drought monitoring.
       For example, a list of various indices grouped by type and ease of application—meteorological, soil moisture indices, hydrological, etc.—can be found at this link: <a href="https://www.droughtmanagement.info/indices/" target="_blank" style="color: #60A5FA;">https://www.droughtmanagement.info/indices/</a>.<br /> On the other hand, in operational work, a smaller number of indices are typically used. Some of the indices used by the European Drought Observatory include the Standardized Precipitation Index (SPI), which is a measure of the intensity and duration of precipitation deficit or surplus.
        Then, the Soil Moisture Index Anomaly, which measures the deviation of water content in the root zone from normal conditions and directly indicates plant stress due to limited water access. The Low-Flow Index, based on simulations of daily river flow and identifies prolonged periods of unusually low flow, and by comparing with historical values, this index provides information about hydrological drought. For vegetation monitoring, the satellite indicator fAPAR (Fraction of Absorbed Photosynthetically Active Radiation) is used, and its negative anomalies indicate poor vegetation condition and reduced productivity. 
        The Standardized Precipitation Evapotranspiration Index (SPEI) is also used, which, in addition to precipitation, includes potential evapotranspiration, thereby indicating water balance deviations. It is particularly useful for monitoring meteorological and agricultural drought in conditions of high temperatures and lack of precipitation, and in the case of longer time periods, it can also indicate the occurrence of hydrological drought. Depending on the index value, three drought categories are usually defined: Extreme drought: SPEI ≤ −2.00; Severe drought: −2.0 < SPEI ≤ −1.5; Moderate drought: −1.5 < SPEI ≤ −1.0.
</p>` +
        `<p style="color: #000;">
The figure on the left shows the time series of the mean value for Serbia, SPEI-6 index for August from 1951 to 2024, by corresponding categories.

      </p>`,
      image: `<img src="${imageSuseMetodologija1}" alt="Drought Introduction" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "TRENDS",
      value: "trends",
      desc:
        `<h2>TRENDS</h2>
      <p style="margin-bottom: 10px; color: #000;">
      During the implementation of the EXTREMES project, the spatiotemporal changes of drought in Serbia were analyzed using the Standardized Precipitation Evapotranspiration Index (SPEI). The analysis included time series of SPEI-1, SPEI-3, SPEI-6, and SPEI-12, calculated based on E-OBS data with a spatial resolution of 0.1° for the period 1950–2022 (Djurdjevic et al., 2024). It was determined that negative trends prevail in all months and for all analyzed time scales of the index, indicating more frequent occurrence of droughts in recent decades. Special focus was placed on SPEI-6 for August, as it is precisely for this month that indices show the most pronounced negative trends, consistent across different time scales of this index. Statistically significant negative trends of SPEI-3, SPEI-6, and SPEI-12 for August were registered on 11%, 17%, and 38% of Serbia's territory. To better understand changes in extreme and severe droughts, Innovative Trend Analysis (ITA) was applied, which showed that the frequency of extreme and severe drought categories in the last 30 years has doubled compared to the previous thirty-year period. The Markov chain also indicated more frequent transitions from neutral and wet to dry categories. The focus on August was additionally motivated by the established significant correlation between SPEI-3, SPEI-6, and SPEI-12 for August and annual corn production in Serbia, confirming the potential of this index for assessing drought impact on agriculture. The relationship between SPEI values and various teleconnection indices, as well as long-term warming trends, was also analyzed, with results showing that changed drought patterns can be linked to the combined effects of global warming and circulation anomalies.
</p>` +
        `<p style="margin-bottom: 10px; color: #000;">
The figure shows time series of SPEI-3, SPEI-6, SPEI-12 indices for August, for Belgrade from 1888 to 2024, and mean values for Serbia from 1950 to 2024.
</p>` +
        `<p style="color: #000;">
Djurdjevic V., Stosic B., Tošić M., Lazić I., Putniković S., Stosic T., Tošić I., 2024, Analysis of recent trends and spatiotemporal changes of droughts over Serbia using high-resolution gridded data, Atmospheric Research, doi: 10.1016/j.atmosres.2024.107376

      </p>`,
      image: `<img src="${imageSuseTrendovi}" alt="Drought Introduction" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "IMPACT",
      value: "impact",
      desc:
        `<h2>IMPACT</h2>
<p style="margin-bottom: 10px; color: #000;">
From 2000 to the present, Serbia has suffered significant damage and losses caused by extreme weather and climate events, with the events causing the greatest material losses mainly related to droughts and floods. Droughts have proven to be the most frequent and "most expensive" events, especially in 2000, 2003, 2007, 2012, 2017, 2022, 2024, and 2025. Summer drought episodes in these years left consequences through very low agricultural production, water supply problems, forest fires, and reduced electricity production, with total losses measured in hundreds of millions of euros, and in some years even exceeding one billion. Overall, the data clearly shows that droughts, especially in the last decade, are the most dominant and economically most damaging extreme events in Serbia.
</p>` +
        `<p style="margin-bottom: 10px; color: #000;">
The figure on the left shows the connection between drought, through the mean value for Serbia of the SPEI index, with recorded negative anomalies in corn production, total agricultural production (World Bank Crop Index and gross value added for agriculture activity), and electricity production from hydroelectric power plants, during the period from 2001 to 2022. In the case of corn production, Djurdjevic et al. (2024) showed a high degree of correlation 0.74 to 0.78 between the corresponding SPEI index and corn production in Serbia.
</p>` +
        `<p style="color: #000;">
Djurdjevic V., Stosic B., Tošić M., Lazić I., Putniković S., Stosic T., Tošić I., 2024, Analysis of recent trends and spatiotemporal changes of droughts over Serbia using high-resolution gridded data, Atmospheric Research, doi: 10.1016/j.atmosres.2024.107376
</p>`,
      image: `<img src="${imageSuseUticaj}" alt="Drought Introduction" style="max-width:100%;height:auto;">`,
      desc2: `<p></p>`,
    },
    {
      label: "DATA",
      value: "data",
      tabs: [
        {
          label: "Past Droughts",
          value: "past-droughts",
          content: (
            <div
              className={`suseDeo ${
                isTabletOrLarger ? "flex" : "flex flex-col"
              }`}
            >
              <div className="suseDeoVeci w-full md:w-2/3 p-4">
                <h3 className="text-lg font-semibold mb-4">Past Droughts</h3>
                <p className="mb-4">
                  Select index, month, and year to view the image:
                </p>

                <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  {/* Filter for SPEI index */}
                  <select
                    value={spei}
                    onChange={(e) => setSpei(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="SPEI-3">SPEI-3</option>
                    <option value="SPEI-6">SPEI-6</option>
                    <option value="SPEI-12">SPEI-12</option>
                  </select>

                  {/* Filter for month */}
                  <select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="Jan">January</option>
                    <option value="Feb">February</option>
                    <option value="Mar">March</option>
                    <option value="Apr">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="Aug">August</option>
                    <option value="Sep">September</option>
                    <option value="Oct">October</option>
                    <option value="Nov">November</option>
                    <option value="Dec">December</option>
                  </select>

                  {/* Filter for year */}
                  <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    {Array.from({ length: 2023 - 1950 + 1 }, (_, index) => (
                      <option key={index} value={1950 + index}>
                        {1950 + index}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Section for image display */}
                <div className="mt-6 w-full md:w-auto">
                  <h4 className="text-lg font-semibold">
                    Displayed image for {spei}, {month}, {year}
                  </h4>
                  <img
                    src={getSelectedImage()}
                    alt={`Image for ${spei}, ${month}, ${year}`}
                    className="w-full md:w-auto max-w-md mx-auto"
                  />
                </div>

                {/* Download buttons */}
                <div className="mt-6 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <a
                    href={getSelectedImage()}
                    download={`Image-${spei}-${month}-${year}.png`}
                    className="bg-blue-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Download Image
                  </a>
                  <a
                    href={getDownloadDataLink()}
                    download={`Data-${spei}-${month}-${year}.nc`}
                    className="bg-green-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Download Data
                  </a>
                  <a
                    href="/spei_netcdf_data.tgz"
                    download="Droughts.tgz"
                    className="bg-red-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Download All Data
                  </a>
                </div>
              </div>

              {/* Section for additional text */}
              <div className="suseDeoManji w-full md:w-1/3 p-4 bg-white border-l">
                <h4 className="text-lg font-semibold">PAST DROUGHTS</h4>
                <p className="mt-4 text-black">
                  Here you can download drought indices SPEI-3, SPEI-6, and
                  SPEI-12, calculated for each month and year from 1950 to 2023.
                  The indices are calculated using E-OBS data. You can download
                  the results in graphical format or in numerical NetCDF format.
                </p>
                <p className="mt-4 text-black">
                  E-OBS data: <br />
                  Cornes, R.C., van der Schrier, G., van den Besselaar, E.J.M.,
                  & Jones, P.D. (2018). An Ensemble Version of the E-OBS
                  Temperature and Precipitation Datasets. Journal of Geophysical
                  Research: Atmospheres, 123, 9391–9409.
                </p>
              </div>
            </div>
          ),
        },
        {
          label: "Future Projections",
          value: "future-projections",
          content: (
            <div
              className={`suseDeo ${
                isTabletOrLarger ? "flex" : "flex flex-col"
              }`}
            >
              <div className="suseDeoVeci w-full md:w-2/3 p-4">
                <h3 className="text-lg font-semibold mb-4">
                  Future Projections
                </h3>
                <p className="mb-4">
                  Select index, month, and year to view the projection:
                </p>

                <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <select
                    value={spei}
                    onChange={(e) => setSpei(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="SPEI-3">SPEI-3</option>
                    <option value="SPEI-6">SPEI-6</option>
                    <option value="SPEI-12">SPEI-12</option>
                  </select>

                  {/* Filter for month */}
                  <select
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="Jan">January</option>
                    <option value="Feb">February</option>
                    <option value="Mar">March</option>
                    <option value="Apr">April</option>
                    <option value="May">May</option>
                    <option value="June">June</option>
                    <option value="July">July</option>
                    <option value="Aug">August</option>
                    <option value="Sep">September</option>
                    <option value="Oct">October</option>
                    <option value="Nov">November</option>
                    <option value="Dec">December</option>
                  </select>

                  <select
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                    className="border p-2 w-full md:w-auto"
                  >
                    <option value="2041-2060">2041-2060</option>
                    <option value="2061-2080">2061-2080</option>
                    <option value="2081-2100">2081-2100</option>
                  </select>
                </div>

                {/* Section for image display */}
                <div className="mt-6 w-full md:w-auto">
                  <h4 className="text-lg font-semibold">
                    Displayed projection for {spei}, {month}, {year}
                  </h4>
                  <img
                    src={getSelectedImageForProjekcije()}
                    alt={`Projection for ${spei}, ${month}, ${year}`}
                    className="w-full md:w-auto max-w-md mx-auto"
                  />
                </div>

                {/* Download buttons */}
                <div className="mt-6 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <a
                    href={getSelectedImageForProjekcije()}
                    download={`Projection-${spei}-${month}-${year}.png`}
                    className="bg-blue-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Download Projection
                  </a>
                  <a
                    href={getDownloadDataLinkForProjekcije()}
                    download={`Data-Projection-${spei}-${month}-${year}_allpct.nc`}
                    className="bg-green-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Download Data
                  </a>
                  <a
                    href="/svi_podaci_projekcije_buducnost_suse.tgz"
                    download="DroughtsProjections.tgz"
                    className="bg-red-500 font-bold text-white px-4 py-2 rounded text-center"
                  >
                    Download All Data
                  </a>
                </div>
              </div>

              {/* Section for additional text */}
              <div className="suseDeoManji w-full md:w-1/3 p-4 border-l">
                <h4 className="text-lg font-semibold">FUTURE PROJECTIONS</h4>
                <p className="mt-4 text-black">
                  Here you can download projections of drought indices SPEI-3,
                  SPEI-6, and SPEI-12, calculated for each month and four
                  different time periods in the future (2021-2040, 2041-2060,
                  2061-2080, 2081-2100). The indices are calculated using
                  results from eight different climate models downloaded from
                  the Digital Climate Atlas of Serbia
                  https://atlas-klime.eko.gov.rs. The selected projections refer
                  to two emission scenarios RCP8.5 and RCP4.5. You can download
                  the results in graphical format or in numerical NetCDF format.
                </p>
                <p className="mt-4 mb-2 text-black">
                  List of used regional climate models:
                </p>
                <ul className="text-black text-md pl-1">
                  <li className="pb-1">- CLMcom-CCLM4-8-17</li>
                  <li className="pb-1">- DMI-HIRHAM5</li>
                  <li className="pb-1">- KNMI-RACMO22E</li>
                  <li className="pb-1">- CLMcom-CCLM4-8-17</li>
                  <li className="pb-1">- KNMI-RACMO22E</li>
                  <li className="pb-1">- CLMcom-CCLM4-8-17</li>
                  <li className="pb-1">- MPI-CSC-REMO2009</li>
                  <li>- MPI-CSC-REMO2009</li>
                </ul>
              </div>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <>
      {isTabletOrLarger && <NavBarEN />}
      {isSmallDevice && <NavBarMobileEN />}
      <div className="container mx-auto text-center min-h-screen md:mb-6">
        <Tabs value={activeTab} className="max-w-screen-xl mx-auto">
          <TabsHeader
            className="bg-transparent flex justify-center flex-wrap md:flex-nowrap mx-2 md:mx-0"
            indicatorProps={{
              className: "bg-gray-900/10 shadow-none !text-gray-900",
            }}
            onChange={(value) => setActiveTab(value)}
          >
            {data.map(({ label, value }) => (
              <Tab className="probaTaba px-2 py-1" key={value} value={value}>
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody>
            {data.map(({ value, tabs, desc, image, desc2 }) => (
              <TabPanel key={value} value={value}>
                {value === "data" ? (
                  <Tabs
                    value={activePodaciTab}
                    onChange={(val) => setActivePodaciTab(val)}
                  >
                    <TabsHeader className="bg-gray-200">
                      {tabs.map(({ label, value }) => (
                        <Tab key={value} value={value}>
                          {label}
                        </Tab>
                      ))}
                    </TabsHeader>
                    <TabsBody>
                      {tabs.map(({ value, content }) => (
                        <TabPanel key={value} value={value}>
                          {content}
                        </TabPanel>
                      ))}
                    </TabsBody>
                  </Tabs>
                ) : (
                  <>
                    {/* Display for other main tabs like Introduction, Methodology, etc. */}
                    <div className="suseDeo flex flex-col md:flex-row">
                      <div className="suseDeoVeci w-full md:w-3/5 p-4">
                        {image && ReactHtmlParser(image)}
                        {desc2 && ReactHtmlParser(desc2)}
                      </div>
                      <div className="suseDeoManji w-full md:w-2/5 p-4 bg-white mt-6 md:mt-0">
                        {desc && ReactHtmlParser(desc)}
                      </div>
                    </div>
                  </>
                )}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>
      <FormEN />
      <FooterEN />
    </>
  );
}
